import axiosClient from "../api/axiosClient";

const ANALYTICS_ENDPOINT = "/analytics/events";

export function generateClientRequestId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `crid_${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}

export function mergeProps(baseProps = {}, props = {}) {
  return { ...(baseProps || {}), ...(props || {}) };
}

export async function track(eventName, props = {}, baseProps = null) {
  const finalProps = baseProps ? mergeProps(baseProps, props) : props;

  try {
    if (process.env.NODE_ENV !== "production") {
      // Keep local visibility during development without blocking UX.
      // eslint-disable-next-line no-console
      console.debug("[analytics]", eventName, finalProps);
    }

    await axiosClient.post(ANALYTICS_ENDPOINT, {
      eventName,
      props: finalProps,
      ts: new Date().toISOString(),
    });
  } catch (err) {
    if (process.env.NODE_ENV !== "production") {
      // Analytics errors are intentionally non-blocking.
      // eslint-disable-next-line no-console
      console.debug("[analytics] failed", eventName, err?.message || err);
    }
  }
}
